// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#login-page{
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background:#DEF3F4;
    z-index: 99;
}

#login-page .container{
    position: relative;
    width: 240px;
    height: 300px;
    padding: 100px 40px 40px 40px;
    box-sizing: content-box;
}

#login-page .box{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    padding: 90px 40px 40px 40px;
    backface-visibility: hidden;
    background: linear-gradient(230deg, rgba(53, 57, 74, 0) 0%, rgb(0, 0, 0) 100%);
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='rgba(53, 57, 74, 0)', endColorstr='rgb(0, 0, 0)',GradientType=1 );
    box-shadow: -15px 15px 15px rgba(0,0,0,.4);
    transition: all 1s;
}
#login-page .showBox{
    transform:rotateY(0deg);
}
#login-page .hiddenBox{
    transform:rotateY(180deg);
}
#login-page .loginBtn{
    padding: 10px 50px;
    border: 2px solid #4FA1D9;
    border-radius: 50px;
    background: transparent;
    font-size: 11px;
    color: #4FA1D9;
    transition: all .2s;
}
#login-page .bottom{
    display: flex;
    height: 42px;
    justify-content: space-between; 
    align-items: center;
}
#login-page .registerBtn{
    color: #D3D7F7;
}
#login-page .registerBtn:hover{
    color: #4FA1D9;
    cursor: pointer;
}
#login-page .loginBtn:hover{
    color: white;
    background: #4FA1D9;
    cursor: pointer;
}
#login-page .title{
    height: 60px;
    color:#D3D7F7;
    font-size: 16px;
    margin-bottom: 0;
}
#login-page .footer{
    position: absolute;
    bottom: 30px;
    left: 35px;
    width: 250px;
    color: #D3D7F7;
    font-size: 10px;
}


/*覆盖antd的默认样式*/
#login-page input{
    color:#61BFFF;
    border:none;
    outline: none;
    box-shadow: none;
    background: transparent;
}
#login-page .ant-input-group-addon{
    background: transparent;
    padding:0;
    border: none;
    color: #fff;
    opacity: 0.8;
}
#login-page .ant-input-group-addon .iconfont{
    display: inline-block;
    width: 30px;
    transition: all .3s;
    opacity: 0.6;
}
#login-page .ant-form-item{
    margin-bottom: 10px;
}
#login-page .ant-form-explain{
    position: absolute;
    z-index: 99;
    left:110%;
    top:0;
    height: 41px;
    /*box-shadow: -2px 2px 2px rgba(0,0,0,.3);*/
}
.login-notification{
    background: transparent;
    border:1px solid #D3D7F7;
    color:#D3D7F7;
    width: 250px;
    height: 80px;
    float: right;
    margin-right: 20px;
}
.login-notification .ant-notification-notice-message{
    color:#D3D7F7;
}
.login-notification .ant-notification-notice-close{
    color:#D3D7F7;
}
/*更改谷歌浏览器input背景*/
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
    /*延迟背景颜色载入*/
    -webkit-transition-delay: 99999s;
    -webkit-transition: color 99999s ease-out, background-color 99999s ease-out;
}`, "",{"version":3,"sources":["webpack://./src/routes/login/style.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,6BAA6B;IAC7B,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,4BAA4B;IAC5B,2BAA2B;IAC3B,8EAA8E;IAC9E,oIAAoI;IACpI,0CAA0C;IAC1C,kBAAkB;AACtB;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,cAAc;IACd,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,YAAY;IACZ,8BAA8B;IAC9B,mBAAmB;AACvB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;IACd,eAAe;AACnB;AACA;IACI,YAAY;IACZ,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,YAAY;IACZ,aAAa;IACb,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,YAAY;IACZ,cAAc;IACd,eAAe;AACnB;;;AAGA,cAAc;AACd;IACI,aAAa;IACb,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,uBAAuB;AAC3B;AACA;IACI,uBAAuB;IACvB,SAAS;IACT,YAAY;IACZ,WAAW;IACX,YAAY;AAChB;AACA;IACI,qBAAqB;IACrB,WAAW;IACX,mBAAmB;IACnB,YAAY;AAChB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,KAAK;IACL,YAAY;IACZ,2CAA2C;AAC/C;AACA;IACI,uBAAuB;IACvB,wBAAwB;IACxB,aAAa;IACb,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;AACA,iBAAiB;AACjB;;;;IAII,WAAW;IACX,gCAAgC;IAChC,2EAA2E;AAC/E","sourcesContent":["#login-page{\n    position: fixed;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background:#DEF3F4;\n    z-index: 99;\n}\n\n#login-page .container{\n    position: relative;\n    width: 240px;\n    height: 300px;\n    padding: 100px 40px 40px 40px;\n    box-sizing: content-box;\n}\n\n#login-page .box{\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    padding: 90px 40px 40px 40px;\n    backface-visibility: hidden;\n    background: linear-gradient(230deg, rgba(53, 57, 74, 0) 0%, rgb(0, 0, 0) 100%);\n    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='rgba(53, 57, 74, 0)', endColorstr='rgb(0, 0, 0)',GradientType=1 );\n    box-shadow: -15px 15px 15px rgba(0,0,0,.4);\n    transition: all 1s;\n}\n#login-page .showBox{\n    transform:rotateY(0deg);\n}\n#login-page .hiddenBox{\n    transform:rotateY(180deg);\n}\n#login-page .loginBtn{\n    padding: 10px 50px;\n    border: 2px solid #4FA1D9;\n    border-radius: 50px;\n    background: transparent;\n    font-size: 11px;\n    color: #4FA1D9;\n    transition: all .2s;\n}\n#login-page .bottom{\n    display: flex;\n    height: 42px;\n    justify-content: space-between; \n    align-items: center;\n}\n#login-page .registerBtn{\n    color: #D3D7F7;\n}\n#login-page .registerBtn:hover{\n    color: #4FA1D9;\n    cursor: pointer;\n}\n#login-page .loginBtn:hover{\n    color: white;\n    background: #4FA1D9;\n    cursor: pointer;\n}\n#login-page .title{\n    height: 60px;\n    color:#D3D7F7;\n    font-size: 16px;\n    margin-bottom: 0;\n}\n#login-page .footer{\n    position: absolute;\n    bottom: 30px;\n    left: 35px;\n    width: 250px;\n    color: #D3D7F7;\n    font-size: 10px;\n}\n\n\n/*覆盖antd的默认样式*/\n#login-page input{\n    color:#61BFFF;\n    border:none;\n    outline: none;\n    box-shadow: none;\n    background: transparent;\n}\n#login-page .ant-input-group-addon{\n    background: transparent;\n    padding:0;\n    border: none;\n    color: #fff;\n    opacity: 0.8;\n}\n#login-page .ant-input-group-addon .iconfont{\n    display: inline-block;\n    width: 30px;\n    transition: all .3s;\n    opacity: 0.6;\n}\n#login-page .ant-form-item{\n    margin-bottom: 10px;\n}\n#login-page .ant-form-explain{\n    position: absolute;\n    z-index: 99;\n    left:110%;\n    top:0;\n    height: 41px;\n    /*box-shadow: -2px 2px 2px rgba(0,0,0,.3);*/\n}\n.login-notification{\n    background: transparent;\n    border:1px solid #D3D7F7;\n    color:#D3D7F7;\n    width: 250px;\n    height: 80px;\n    float: right;\n    margin-right: 20px;\n}\n.login-notification .ant-notification-notice-message{\n    color:#D3D7F7;\n}\n.login-notification .ant-notification-notice-close{\n    color:#D3D7F7;\n}\n/*更改谷歌浏览器input背景*/\ninput:-webkit-autofill,\ninput:-webkit-autofill:hover,\ninput:-webkit-autofill:focus,\ninput:-webkit-autofill:active {\n    /*延迟背景颜色载入*/\n    -webkit-transition-delay: 99999s;\n    -webkit-transition: color 99999s ease-out, background-color 99999s ease-out;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
